import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    document.addEventListener("submit", this.handleSubmit);
    document.addEventListener("turbo:submit-start", this.handleSubmit);
    document.addEventListener("turbo:render", this.resetButtons);
  }

  disconnect() {
    document.removeEventListener("submit", this.handleSubmit);
    document.removeEventListener("turbo:submit-start", this.handleSubmit);
    document.removeEventListener("turbo:render", this.resetButtons);
  }

  resetButtons = () => {
    // Find all submit buttons with the loading class and reset them
    const loadingButtons = document.querySelectorAll(
      'button[type="submit"].loading',
    );
    loadingButtons.forEach((button) => {
      button.classList.remove("loading");
      button.disabled = false;
    });
  };

  handleSubmit = (event) => {
    let form;
    if (event.target instanceof HTMLFormElement) {
      form = event.target;
    } else if (
      event.detail?.formSubmission?.element instanceof HTMLFormElement
    ) {
      // Handle Turbo submission
      form = event.detail.formSubmission.element;
    }

    if (form) {
      const submitButtons = form.querySelectorAll('button[type="submit"]');
      submitButtons.forEach((button) => {
        button.classList.add("loading");
        button.disabled = true;
      });
    }
  };
}
